import { render } from "./NContacts.vue?vue&type=template&id=7d82c8cc"
import script from "./NContacts.vue?vue&type=script&lang=js"
export * from "./NContacts.vue?vue&type=script&lang=js"

import "./NContacts.vue?vue&type=style&index=0&id=7d82c8cc&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__